<script lang="ts" setup>
defineProps<{ id: 'characteristics' | 'videos' | 'reviews' | 'description'; title: string }>();

const { productPageFoldableBlocks } = storeToRefs(useCatalogStore());

watch(
  () => productPageFoldableBlocks.value,
  () => {
    sessionStorage.setItem('productPageFoldableBlocks', JSON.stringify(productPageFoldableBlocks.value));
  },
  { deep: true },
);
</script>

<template>
  <div
    :id="id"
    class="w-full"
  >
    <button
      :name="`product ${id}`"
      class="font-bold flex items-center gap-2"
      @click="productPageFoldableBlocks[id] = !productPageFoldableBlocks[id]"
    >
      <h2>{{ title }}</h2>

      <SvgoChevronDown
        :class="{ 'rotate-180': productPageFoldableBlocks[id] }"
        :font-controlled="false"
        class="size-5"
        filled
      />
    </button>

    <FoldableBlock v-model="productPageFoldableBlocks[id]">
      <slot />
    </FoldableBlock>
  </div>
</template>
